import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../Button';
import styles from './live-classes.module.scss';

const LiveClasses = ({className}) => (
  <section
    className={classNames(styles.LiveClasses, 'section bg-party', className)}
  >
    <div className="container">
      <div className="has-text-white has-text-centered">
        <div className={classNames(styles.LiveClasses__heading)}>
          <h1 className="is-size-2">Free Live Classes</h1>
          <p className="is-size-5">Learn from the TeamGantt experts</p>
        </div>

        <Button
          className={classNames(styles.LiveClasses__button)}
          href="https://www.teamgantt.com/classes"
          inverted={true}
        >
          View Upcoming Classes
        </Button>
      </div>
    </div>
  </section>
);

LiveClasses.propTypes = {
  className: PropTypes.string,
};

export default LiveClasses;



// WEBPACK FOOTER //
// ./src/components/live-classes/index.js